import type { SVGProps } from 'react';

export type EyeIconProps = SVGProps<SVGSVGElement> & {
  size?: number;
  /** When true, render the slashed (hidden) variant. */
  off?: boolean;
};

export const EyeIcon = ({ size = 16, off, ...rest }: EyeIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    role="img"
    aria-hidden
    {...rest}
  >
    <title>{off ? 'hidden' : 'visible'}</title>
    <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z" />
    <circle cx="12" cy="12" r="2.6" />
    {off && <line x1="3" y1="3" x2="21" y2="21" />}
  </svg>
);
